"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import AdvantageComp from "./components/advantages";
import EmpoweringComponent from "./components/empowering";
import OfferingsComponent from "./components/offerings";
import WhyChooseComponent from "./components/whyChoose";
import DifferenceComponent from "./components/difference";
import DeploymentComponent from "./components/deployment";
import CustomerReviewComponent from "./components/customerReview";
import ExtendComponent from "./components/extend";
import UseCasesComponent from "./components/workload";
import TransferCta from "./components/transferCta";
import Architecture from "./components/architecture";
import ServiceArchitecture from "./components/serviceArchitecture";

const OpenStackCloudPage = () => {
  return (
    <>
      <PageLayout>
        <Hero />
        <PrivateCloudTabs />
        <Intro />
        <AdvantageComp />
        <EmpoweringComponent />
      </PageLayout>
      <OfferingsComponent />
      <PageLayout>
        <Architecture />
        <WhyChooseComponent />
        <FeaturesComponent />
        <ServiceArchitecture />
      </PageLayout>
      <DifferenceComponent />
      <PageLayout>
        <DeploymentComponent />
      </PageLayout>
      <UseCasesComponent />
      <PageLayout showContactForm>
        <CustomerReviewComponent />
        <ExtendComponent />
        <TransferCta />
        <Faqs />
      </PageLayout>
    </>
  );
};

export default OpenStackCloudPage;
